export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-force/src/jiggle.js
// module id = 207
// module chunks = 0